
export const OEComponentLockFlags = {
    none:                               0,
    renderMode:                         1 << 0,
    activation:                         1 << 1,
    switch:                             1 << 2,
    all:                                (1 << 3) - 1
};

OEComponentLockFlags.activationSwitch = OEComponentLockFlags.activation | OEComponentLockFlags.switch;

//
export const OEComponentCategoryMode = {
    static:                             0,
    switch:                             1,
    activation:                         2
};

//
export const OEComponentSceneObjPropertyBits = {
    none:                               0,
    disableHighlighting:                1 << 0,
    passthrough:                        1 << 1,
    cameraTransform:                    1 << 2,
    all:                                0xffffffff
};

OEComponentSceneObjPropertyBits.def = OEComponentSceneObjPropertyBits.cameraTransform;

//
export const OEComponentTreeIcons = {
    extCollapsed:                       '\uF078',
    extNotCollapsed:                    '\uF077',
    highlighting:                       '\u1FF1',
    passthrough:                        '\uF0A7',
    cameraTransform:                    '\uF03D',
};

//
export const OEComponentTreeBtnIds = {
    highlightingProperty:               'highlightingProperty',
    passthroughProperty:                'passthroughProperty',
    cameraTransformProperty:            'cameraTransformProperty',
};